import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import hrlabLogo from "../Images/hrlab.png";
import "../styles/Header/header.css";
import ContactUs from "./ContactUs";
import ContactUs1 from "./ContactUs1";

export default function Header() {
  const [showSidebar, setShowSidebar] = useState(false);
  const location = useLocation();

  const toggleSidebar = () => {
    setShowSidebar((prevState) => !prevState);
  };

  const closeSidebar = () => {
    setShowSidebar(false);
  };

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/">
          <img src={hrlabLogo} alt="HR Labs Logo" className="logo" />
        </Link>
        <ul className="nav-links">
          <li>
            <Link to="/" className={location.pathname === "/" ? "active" : ""}>
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/Consulting"
              className={location.pathname === "/Consulting" ? "active" : ""}
            >
              Consulting
            </Link>
          </li>
          <li>
            <Link
              to="/Products"
              className={
                location.pathname === "/Products" ||
                location.pathname === "/Company"
                  ? "active"
                  : ""
              }
            >
              What We Do
            </Link>
          </li>
          <li>
            <Link
              to="/Careers"
              className={location.pathname === "/Careers" ? "active" : ""}
            >
              Careers
            </Link>
          </li>
          <li>
            <Link
              to="/Partners"
              className={location.pathname === "/Partners" ? "active" : ""}
            >
              Partners
            </Link>
          </li>

          <li>
            <Link
              to="/Digicloud"
              className={`sidebar-link ${
                location.pathname === "/Digicloud"
                  ? "active digicloud-special"
                  : "digicloudNav"
              }`}
              onClick={closeSidebar}
            >
              <span>
                <span style={{ color: "#6fef6f" }}>Digi</span>
                <span style={{ color: "#51a7ed" }}>Cloud</span>
              </span>
            </Link>
          </li>
        </ul>
        <div>
          <ContactUs className="button-3" />
        </div>
        <div className="mobile-menu">
          <button onClick={toggleSidebar}>
            {showSidebar ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {showSidebar && (
        <nav className="sidebar">
          <div className="sidebar-content">
            <button className="close-btn" onClick={closeSidebar}>
              <FaTimes />
            </button>
            <Link
              to="/"
              className={`sidebar-link ${
                location.pathname === "/" ? "active" : ""
              }`}
              onClick={closeSidebar}
            >
              Home
            </Link>
            <Link
              to="/Consulting"
              className={`sidebar-link ${
                location.pathname === "/Consulting" ? "active" : ""
              }`}
              onClick={closeSidebar}
            >
              Consulting
            </Link>
            <Link
              to="/Products"
              className={`sidebar-link ${
                location.pathname === "/Products" ? "active" : ""
              }`}
              onClick={closeSidebar}
            >
              What We Do
            </Link>
            <Link
              to="/Company"
              className={`sidebar-link submenu-item ${
                location.pathname === "/Company" ? "active" : ""
              }`}
              onClick={closeSidebar}
            >
              Company
            </Link>
            <Link
              to="/Careers"
              className={`sidebar-link ${
                location.pathname === "/Careers" ? "active" : ""
              }`}
              onClick={closeSidebar}
            >
              Careers
            </Link>
            <Link
              to="/Partners"
              className={`sidebar-link ${
                location.pathname === "/Partners" ? "active" : ""
              }`}
              onClick={closeSidebar}
            >
              Partners
            </Link>

            <Link
              to="/Digicloud"
              className={`sidebar-link ${
                location.pathname === "/Digicloud"
                  ? "active digicloud-special"
                  : "digicloudNav"
              }`}
              onClick={closeSidebar}
            >
              <span>
                <span style={{ color: "#6fef6f" }}>Digi</span>
                <span style={{ color: "#51a7ed" }}>Cloud</span>
              </span>
            </Link>

            <ContactUs1 className="btn-4" />
          </div>
        </nav>
      )}
    </header>
  );
}
